var map = {
	"./de/bg-line-mecha.png": "snGa",
	"./en/bg-line-mecha.png": "e9OF",
	"./es/bg-line-mecha.png": "Q7aS",
	"./fr/bg-line-mecha.png": "WQQv",
	"./ja/bg-line-mecha.png": "SnJ3",
	"./ko/bg-line-mecha.png": "vQ/o",
	"./pt/bg-line-mecha.png": "PDCN",
	"./ru/bg-line-mecha.png": "z7XT",
	"./tc/bg-line-mecha.png": "zryF",
	"./th/bg-line-mecha.png": "fLGs"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NBSG";